module.exports = __webpack_public_path__ + "static/img/logo12.bcd16af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo12.png
// module id = OmaH
// module chunks = 1